import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/**
 * Koshiki-no-Kata — Omote (14) + Ura (7).
 * Labels follow Kodokan performance order; spelling verification ≠ textbook verification.
 */
export const koshikiNoKata: KataDefinition = withOpeningAndClosingBows({
  id: 'koshiki-no-kata',
  name: 'Koshiki-no-Kata',
  nameJa: '古式の形',
  theme: {
    from: '#9f1239',
    to: '#d97706',
    text: '#fff8eb',
  },
  groups: [
    {
      id: 'omote',
      name: 'Omote',
      nameJa: '表',
      techniques: [
        { id: 'koshiki-tai', name: 'Tai', nameJa: '体' },
        { id: 'koshiki-yume-no-uchi', name: 'Muchu', nameJa: '夢中' },
        { id: 'koshiki-ryokuhi', name: 'Chikara-yoke', nameJa: '力避' },
        { id: 'koshiki-mizu-guruma', name: 'Mizu-guruma', nameJa: '水車' },
        { id: 'koshiki-mizu-nagare', name: 'Mizu-nagare', nameJa: '水流' },
        { id: 'koshiki-hiki-otoshi', name: 'Hiki-otoshi', nameJa: '曳落' },
        { id: 'koshiki-ko-daore', name: 'Ko-daore', nameJa: '虚倒' },
        { id: 'koshiki-uchikudaki', name: 'Uchi-kudaki', nameJa: '打砕' },
        { id: 'koshiki-tani-otoshi', name: 'Tani-otoshi', nameJa: '谷落' },
        { id: 'koshiki-kuruma-daore', name: 'Kuruma-daore', nameJa: '車倒' },
        { id: 'koshiki-shikoro-dori', name: 'Shikoro-dori', nameJa: '錣取' },
        { id: 'koshiki-shikoro-gaeshi', name: 'Shikoro-gaeshi', nameJa: '錣返' },
        { id: 'koshiki-yudachi', name: 'Yudachi', nameJa: '夕立' },
        { id: 'koshiki-taki-otoshi', name: 'Taki-otoshi', nameJa: '滝落' },
      ],
    },
    {
      id: 'ura',
      name: 'Ura',
      nameJa: '裏',
      techniques: [
        { id: 'koshiki-mi-kudaki', name: 'Mi-kudaki', nameJa: '身砕' },
        { id: 'koshiki-kuruma-gaeshi', name: 'Kuruma-gaeshi', nameJa: '車返' },
        { id: 'koshiki-mizu-iri', name: 'Mizu-iri', nameJa: '水入' },
        { id: 'koshiki-ryusetsu', name: 'Ryu-setsu', nameJa: '柳雪' },
        { id: 'koshiki-sakaotoshi', name: 'Saka-otoshi', nameJa: '坂落' },
        { id: 'koshiki-yukiore', name: 'Yuki-ore', nameJa: '雪折' },
        { id: 'koshiki-iwa-nami', name: 'Iwa-nami', nameJa: '岩波' },
      ],
    },
  ],
})
